import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=5b9e0c31"
import script from "./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue?vue&type=script&lang=js"
import style0 from "./redirect.vue?vue&type=style&index=0&id=5b9e0c31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports